module.exports = __webpack_public_path__ + "img/battery-green.4f810a32.svg";